import React from "react";
import { Avatar } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

type SchoolLogoAvatarProps = {
  src?: string;
  alt?: string;
  className?: string;
};

const SchoolLogoAvatar: React.FC<SchoolLogoAvatarProps> = ({
  src,
  alt = "School",
  className,
}) => (
  <Avatar
    alt={alt}
    src={src}
    className={className}
    sx={{
      bgcolor: "#e0e0e0",
      color: "#757575",
    }}
  >
    <PersonIcon />
  </Avatar>
);

export default SchoolLogoAvatar;
